import { useContext } from 'react';
import type { FormattedItem } from '../../types';
import Context from '../../Context';

export interface LineItemsHook {
  lineItems: FormattedItem[];
}

export default function useLineItems(): LineItemsHook {
  const { job } = useContext(Context);

  return {
    lineItems: job?.lineItems || [],
  };
}
